import { useContext } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";

import { useAuth } from "@api";
import { Heading } from "@components/Headings";
import { OrgContext, UserContext } from "@providers";

import { slugifyOrgName } from "@pages/dashboard/utils";
import { ProjectTypeButton } from "@pages/setup/components";

const AddProjectsDialogWrapper = styled.div`
  padding: 16px 32px;
`;

const AddProjectsDialogHeading = styled.div`
  margin: 8px;
`;

export function SelectOrgDialog() {
  const { setOrg } = useContext(OrgContext);
  const { user } = useContext(UserContext);
  const { install } = useAuth();
  const history = useHistory();
  if (!user) {
    throw new Error("Need to be logged in");
  }

  const userGithubOrgs = user.orgs.filter((o) => o.source_type === "github");
  const addOrgButtonText = `${
    userGithubOrgs.length > 0 ? "Other" : "Install"
  } GitHub Organization`;

  return (
    <AddProjectsDialogWrapper>
      <AddProjectsDialogHeading>
        <Heading>Select GitHub organization</Heading>
      </AddProjectsDialogHeading>
      <div>
        {userGithubOrgs.map((newOrg) => (
          <ProjectTypeButton
            key={newOrg.name}
            onClick={() => {
              setOrg(newOrg);
              history.push(
                `/orgs/${slugifyOrgName(newOrg.name)}/setup/github/repos`
              );
            }}
            title={newOrg.name}
            icon={faGithub}
          />
        ))}
      </div>

      <ProjectTypeButton
        title={addOrgButtonText}
        icon={faPlusCircle}
        onClick={async () => {
          await install("github");
        }}
      />
    </AddProjectsDialogWrapper>
  );
}
